// p2p, payment, payout transactions
export const lockSupportConfig = [
    'p2pInstances',
    'paymentInstances',
    'payoutInstances',
];